import { render, staticRenderFns } from "./KonzessionsAbgabenRow.vue?vue&type=template&id=8971882e&scoped=true&"
import script from "./KonzessionsAbgabenRow.vue?vue&type=script&lang=js&"
export * from "./KonzessionsAbgabenRow.vue?vue&type=script&lang=js&"
import style0 from "./KonzessionsAbgabenRow.vue?vue&type=style&index=0&id=8971882e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8971882e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet})
